import { useEffect, useState } from 'react'

const HIGHLIGHT_NAME = 'table-search-match'

export function useTableHighlight(
  rootRef: React.RefObject<HTMLElement>,
  searchText: string,
  debounceMs: number = 300
) {
  const [debouncedText, setDebouncedText] = useState(searchText)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedText(searchText.trim().length >= 2 ? searchText : '')
    }, debounceMs)
    return () => clearTimeout(timer)
  }, [searchText, debounceMs])

  useEffect(() => {
    if (!CSS.highlights || !rootRef.current) return
    CSS.highlights.delete(HIGHLIGHT_NAME)

    const query = debouncedText.trim().toLowerCase()
    if (!query) return

    const ranges: Range[] = []
    const root = rootRef.current
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
    let currentNode = walker.nextNode()

    while (currentNode) {
      const textValue = currentNode.textContent?.toLowerCase()

      if (textValue && textValue.includes(query)) {
        let startPos = 0
        let index = textValue.indexOf(query, startPos)
        while (index !== -1) {
          const range = new Range()
          range.setStart(currentNode, index)
          range.setEnd(currentNode, index + query.length)
          ranges.push(range)

          startPos = index + query.length
          index = textValue.indexOf(query, startPos)
        }
      }
      currentNode = walker.nextNode()
    }

    if (!ranges.length) return
    const highlight = new Highlight(...ranges)
    CSS.highlights.set(HIGHLIGHT_NAME, highlight)

    return () => {
      CSS.highlights.delete(HIGHLIGHT_NAME)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedText])
}
